import React, { useEffect, useState } from 'react'
import intl from 'react-intl-universal'
import { Badge, Ellipsis } from 'antd-mobile'
import { useNavigate, useLocation } from 'react-router-dom'
import { getScopeParam, getHeadStoreInfoSession } from '../../utils/session/store'
import { getMemberInfo, getOwnStores } from '../../utils/storage/store'
import { formatJSON, isAppleBrowser } from '../../utils'
import { getMyCouponCountModel } from '../../model/store'
import HotIcon from '../Icon/HotIcon'
import HomeIcon from '../Icon/HomeIcon'
import UserIcon from '../Icon/UserIcon'
import RobotIcon from '../Icon/RobotIcon'
// import { getLoginInfo } from '../../utils/storage/tour'
import './index.less'
// const activeColor = '#418379'
const activeColor = 'var(--adm-color-primary)'
const NavigationBar = ({ current = 0, callback, couponFlag = false }) => {
    const [notUseCoupon, setNotUseCoupon] = useState(0)
    const navigate = useNavigate()
    const location = useLocation()
    // const loginInfo = getLoginInfo() || {}
    // const { token } = loginInfo
    const chainInfo = getHeadStoreInfoSession()
    const { extendColumn, extendColumn1 } = chainInfo || {}

    const { isCheckDiscover = false, isCheckAIAssistant = false } = formatJSON(extendColumn) || {}
    const { isOpenAiChat = false, aiChatType = '' } = formatJSON(extendColumn1) || {}
    // console.log(isCheckDiscover, isCheckAIAssistant, '====////=====isCheckDiscover,isCheckAIAssistant')

    // 基础高度
    const baseHeight = 53
    // 检查是否为 iOS 设备
    const isApple = isAppleBrowser()
    // 计算实际高度
    const height = isApple ? baseHeight + 20 : baseHeight

    const goToView = (view, token, search) => {
        const scopeParam = getScopeParam()
        const { areaId } = scopeParam
        // if (token && token.access_token) {
        navigate(`${view}?areaid=${areaId}`, { state: { from: location.hash, action: 'nav' } })
        // } else {
        //     navigate({ pathname: '/login', state: { from: location.hash }, search })
        // }
    }

    const getActiveColor = (index, current) => {
        return index === current ? activeColor : '#b6b6b6'
    }

    useEffect(() => {
        if (couponFlag) {
            const memberInfo = getMemberInfo()
            const { memberId } = memberInfo || {}
            const stores = getOwnStores() || []
            const storeIds = stores.map(item => item.storeId)
            getMyCouponCountModel({ memberId, storeIdList: storeIds.join(), status: 1 }, true).
                then(res => {
                    // const notUseCoupon = res.filter(item => item.couponState === 1).length
                    setNotUseCoupon(res)
                }).catch(err => {
                    console.log(err)
                })
        }
    }, [])

    return (
        <div style={{ height }}>
            <div className='nav-bar jm-flex'>
                <div
                    onClick={() => {
                        if (current !== 0) {
                            goToView('/home')
                        } else {
                            callback && setTimeout(() => callback(), 100)
                        }
                    }}
                    className={`jm-flex-item nav-item ${current === 0 ? 'current' : ''}`}>
                    <div><HomeIcon width={24} height={24} color={getActiveColor(0, current)} /></div>
                    <div className='fs-12'><Ellipsis content={intl.get('h_home_page').d('Home')} /></div>
                </div>
                {
                    isCheckDiscover && (
                        <div
                            onClick={() => {
                                goToView('/discover')
                            }}
                            className={`jm-flex-item nav-item ${current === 3 ? 'current' : ''}`}>
                            <div> <HotIcon width={28} height={28} color={getActiveColor(3, current)} />  </div>
                            <div className='fs-12'>{intl.get('h_discover').d('Discover')}</div>
                        </div>
                    )
                }
                {
                    (isCheckAIAssistant && isOpenAiChat && aiChatType === 1) && (
                        <div
                            onClick={() => {
                                if (current !== 1) {
                                    goToView('/chat')
                                }
                            }}
                            className={`jm-flex-item nav-item ${current === 1 ? 'current' : ''}`}>
                            <div><RobotIcon width={26} height={26} color={getActiveColor(1, current)} /></div>
                            <div className='fs-12'>{intl.get('h_chat').d('Chat')}</div>
                        </div>
                    )
                }
                <div
                    onClick={() => current !== 2 && goToView('/center')}
                    className={`jm-flex-item nav-item ${current === 2 ? 'current' : ''}`}>
                    <div>
                        {
                            couponFlag && notUseCoupon > 0 ?
                                <Badge content={notUseCoupon} bordered>
                                    <UserIcon width={24} height={24} color={getActiveColor(2, current)} />
                                </Badge>
                                :
                                <UserIcon width={24} height={24} color={getActiveColor(2, current)} />

                        }
                    </div>
                    <div className='fs-12'>{intl.get('hotel_my').d('Me')}</div>
                </div>
            </div>
        </div>
    )
}

export default NavigationBar
